export default __webpack_public_path__ + "static/media/je.6de288e0.jpg";